import { getBrand, getBrandGroup, getPurposeId } from '../../core/pure/Env'
import { getAuth0Feature } from '../../core/pure/Window'
import { api, apiPath } from './util'

export type Purpose = {
  html?: string
  settingsText: string
  settingsCheckboxText: string
  settingsExtraInfoText: string
  title: string
  titleImageUrl?: string
  version: string
}

export const getPurposeCopy = async (): Promise<Purpose> => {
  const isAuth0Enabled = getAuth0Feature()

  return await fetch(
    `${api}${apiPath}${isAuth0Enabled ? getBrandGroup() : getBrand()}/purpose/${getPurposeId()}/copy/`,
  ).then((res) => {
    if (res.ok) return res.json()

    throw new Error(res.statusText)
  })
}
